var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.173,
    height: 18.232,
    viewBox: "0 0 18.173 18.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160708",
    "data-name": "Group 160708",
    transform: "translate(-319.945 -495.868)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1197",
    "data-name": "Rectangle 1197",
    width: 17.994,
    height: 18,
    transform: "translate(320 496)",
    fill: "#ffecd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 17.994,
    height: 18,
    transform: "translate(320 496)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M19.662,19.022H17.241a.591.591,0,0,1,0-1.182h2.421a.591.591,0,0,1,0,1.182Z",
    transform: "translate(316.182 491.935)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502",
    width: 17.94,
    height: 17.946,
    transform: "translate(320.06 496)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M6.279,10.673A1.349,1.349,0,0,1,7.551,9.327h4.883V5.79H1.61V9.466a1.27,1.27,0,0,0,1.2,1.346H6.279v-.148Z",
    transform: "translate(318.94 494.125)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-forward",
    d: "M19.143,4.93,20.67,6.456,19.143,7.917m1.329-1.461H17.42",
    transform: "translate(316.044 494.284)",
    fill: "none",
    stroke: "#f49b31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-forward-2",
    d: "M4.226,15.5,2.7,17.026l1.526,1.461M2.9,17.026H5.95",
    transform: "translate(318.744 492.357)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 0.468,
    cy: 0.468,
    r: 0.468,
    transform: "translate(336.96 510.545)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M5.862,8.482H3.441a.591.591,0,1,1,0-1.182H5.862a.591.591,0,0,1,0,1.182Z",
    transform: "translate(318.718 493.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160707",
    "data-name": "Group 160707",
    transform: "translate(-56.94 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    d: "M11.088,1.57H2.956A1.347,1.347,0,0,0,1.61,2.916v.64H12.434v-.64A1.415,1.415,0,0,0,11.088,1.57Z",
    transform: "translate(375.88 495.898)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986-2",
    "data-name": "Rectangle_986",
    width: 17.994,
    height: 18,
    transform: "translate(376.94 497)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M19.915,17.093V16.33H9.23v3.66A1.312,1.312,0,0,0,10.543,21.3h8.05a1.323,1.323,0,0,0,1.247-.886",
    transform: "translate(374.453 493.196)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154-2",
    "data-name": "Path 1154",
    d: "M19.662,19.022H17.241a.591.591,0,0,1,0-1.182h2.421a.591.591,0,0,1,0,1.182Z",
    transform: "translate(373.122 492.935)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502-2",
    "data-name": "Rectangle_502",
    width: 17.94,
    height: 17.946,
    transform: "translate(377 497)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    d: "M18.6,12.23H10.553A1.318,1.318,0,0,0,9.24,13.557v.663H19.925v-.663a1.318,1.318,0,0,0-1.313-1.327h0Z",
    transform: "translate(374.451 493.955)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-forward-2-2",
    "data-name": "arrow-forward",
    d: "M19.143,4.93,20.67,6.456,19.143,7.917m1.329-1.461H17.42",
    transform: "translate(372.984 495.284)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-forward-2-3",
    "data-name": "arrow-forward-2",
    d: "M4.226,15.5,2.7,17.026l1.526,1.461M2.9,17.026H5.95",
    transform: "translate(375.684 493.357)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193-2",
    "data-name": "Ellipse 193",
    cx: 0.468,
    cy: 0.468,
    r: 0.468,
    transform: "translate(393.9 511.545)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156-2",
    "data-name": "Path 1156",
    d: "M5.862,8.482H3.441a.591.591,0,1,1,0-1.182H5.862a.591.591,0,0,1,0,1.182Z",
    transform: "translate(375.657 494.853)",
    fill: "#787f88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferWhiteIcon);
export default __webpack_public_path__ + "static/media/transfer-white-icon.41ebb8b4d5cae9070467fa5224c261d3.svg";
export { ForwardRef as ReactComponent };